<template>
  <div class="ion-page">
    <template v-if="form.type === 'prestart'">
      <ion-header class="ion-no-border">
        <div class="form-complete-banner" :class="[result]"></div>
      </ion-header>
      <ion-content class="ion-padding">
        <div class="text-center" v-if="result === 'pass'">
          <h1 class="form-complete-title">Machine OK to operate</h1>
          <h4>No issues identified.</h4>
        </div>
        <div class="text-center" v-else-if="result === 'warn'">
          <h1 class="form-complete-title">Machine OK to operate</h1>
          <h4>
            Non-critical issues have been identified that require attention.
          </h4>
        </div>
        <div class="text-center" v-else-if="result === 'critical'">
          <h1 class="form-complete-title">Do not operate machine</h1>
          <h4>Critical issues have been identified that require attention.</h4>
        </div>
      </ion-content>
      <ion-footer>
        <div class="ion-padding">
          <ion-button expand="block" @click="onFinishPrestart"
            >I understand</ion-button
          >
        </div>
      </ion-footer>
    </template>
    <template v-else-if="form.type === 'hire'">
      <div class="form-complete-container">
        <div>
          Form completed successfully
        </div>
      </div>
    </template>
    <template v-else>
      <div class="form-complete-container">
        <div>
          Form completed successfully
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "FormComplete",
  props: ["form", "result"],
  methods: {
    onFinishPrestart() {
      return this.$ionic.actionSheetController
        .create({
          header: `Complete inspection`,
          buttons: [
            {
              text: "Accept & Exit",
              handler: () => {
                this.$emit("done");
              }
            },
            {
              text: "Share Prestart",
              handler: () => {}
            },
            { text: "Cancel", role: "cancel" }
          ]
        })
        .then(a => a.present());
    }
  }
};
</script>

<style lang="scss" scoped>
.form-complete-container {
  display: flex;
  height: 100%;
  width: 100%;
  position: absolute;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.form-complete {
  &-title {
    font-weight: bold;
  }
  &-banner {
    width: 100%;
    height: 36vh;
    background-size: cover;
    background-position: center;
    &.pass {
      background-image: url("../../assets/mobile-landscape-good.png");
    }
    &.warn {
      background-image: url("../../assets/mobile-landscape-ok.png");
    }
    &.critical {
      background-image: url("../../assets/mobile-landscape-bad.png");
    }
  }
}
</style>
